export const LeaveTypeConstants = [
    { label: "Core", value: "core" },
    { label: "Additional", value: "additional" },
];

export const coreLeaveTypeConstant = 'core'
export const additionalLeaveTypeConstant = 'additional'

